export default __webpack_public_path__ + "static/media/instagram.66c0443f.svg";